import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Users, Building2, Briefcase, Send, CheckCircle2 } from "lucide-react";

export default function AdminHome() {
    const [stats, setStats] = useState({});
    const [users, setUsers] = useState([]);

    useEffect(() => {
        api.get("/admin/stats").then(({ data }) => setStats(data.data));
        api.get("/admin/users").then(({ data }) => setUsers(data.data || []));
    }, []);

    const kpis = [
        { label: "Utenti", val: stats.users, icon: Users },
        { label: "Professionisti", val: stats.professionals, icon: Users },
        { label: "Strutture", val: stats.facilities, icon: Building2 },
        { label: "Annunci", val: stats.jobs, icon: Briefcase },
        { label: "Candidature", val: stats.applications, icon: Send },
        { label: "Collaborazioni", val: stats.collaborations, icon: CheckCircle2 },
    ];

    return (
        <div className="max-w-6xl mx-auto">
            <h1 className="font-display text-3xl font-bold tracking-tight">Admin dashboard</h1>
            <p className="text-sm text-[#5C5C5C] mt-1 mb-6">Overview della piattaforma</p>
            <div className="grid md:grid-cols-3 lg:grid-cols-6 gap-3 mb-8">
                {kpis.map((k, i) => (
                    <div key={i} className="hl-card p-4" data-testid={`admin-kpi-${k.label.toLowerCase()}`}>
                        <k.icon className="w-5 h-5 text-[#1C3F39]" />
                        <div className="mt-3 font-display text-2xl font-bold font-mono">{k.val ?? 0}</div>
                        <div className="text-xs text-[#5C5C5C]">{k.label}</div>
                    </div>
                ))}
            </div>
            <div className="hl-card p-6">
                <h2 className="font-display font-bold text-lg mb-4">Utenti recenti</h2>
                <div className="divide-y divide-[#E5E5E0]">
                    {users.slice(0, 30).map((u) => (
                        <div key={u.id} className="py-3 flex items-center justify-between" data-testid={`admin-user-${u.id}`}>
                            <div>
                                <div className="font-semibold">{u.full_name}</div>
                                <div className="text-xs text-[#5C5C5C]">{u.email}</div>
                            </div>
                            <Badge variant="outline" className="capitalize">{u.role}</Badge>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
